// extracted by mini-css-extract-plugin
export default {"main":"T5-z"};